import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import cardAlt from "@static/img/icons/card-alt.png";

interface IParams {
    isIframeDisplayed: boolean;
    closeIframe(): void;
    loadIframe(): void;
}

export const PaymentCardAction = (props: IParams) => {
    const { isIframeDisplayed, closeIframe, loadIframe } = props;
    const { t } = useTranslation(["payment", "common"]);

    return (
        <CardActions className="card-footer">
            <Grid className="payment-add" container justify="center">
                {isIframeDisplayed && (
                    <Grid item md={3} sm={4} xs={6}>
                        <Button className="card-footer__button" fullWidth size="large" onClick={closeIframe}>
                            {t("common:cancel")}
                        </Button>
                    </Grid>
                )}
                {!isIframeDisplayed && (
                    <Grid item md={4} sm={5} xs={12}>
                        <Button className="card-footer__button" fullWidth size="large" onClick={loadIframe}>
                            <img alt="add card" src={cardAlt} />
                            {t("payment:addNewCard")}
                        </Button>
                    </Grid>
                )}
            </Grid>
        </CardActions>
    );
};
